<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <h1 to="/">SmartSolar</h1>

      <v-spacer />

      <v-btn
        v-if="signedIn && false"
        color="accent"
        to="/download"
        width="128px"
      >
        Download
      </v-btn>

      <v-btn
        v-if="!signedIn"
        color="accent"
        to="/signin"
        width="128px"
      >
        Sign in
      </v-btn>

      <v-menu
        v-if="signedIn"
        offset-y
        close-on-click
      >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar
            class="ml-4"
            color="accent"
            v-bind="attrs"
            v-on="on"
          >
            <span class="white--text headline"> {{ firstLetterUsername }} </span>
          </v-avatar>
        </template>

        <v-list>
          <v-list-item v-on:click="showSignout = true">
            <v-list-item-title>
              Sign out
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="secondary fill-height">
      <router-view />

      <Message />
      <Signout
        v-bind:show.sync="showSignout"
      />
    </v-main>
  </v-app>
</template>

<script>
import Message from '@/components/message.vue'
import Signout from '@/components/signout.vue'

export default {
  name: 'App',
  components: {
    Message,
    Signout
  },
  data () {
    return {
      showSignout: false,
    }
  },
  computed: {
    signedIn () {
      return this.$store.getters.signedIn
    },
    firstLetterUsername () {
      return this.$store.getters.firstLetterUsername
    }
  },
}
</script>
